import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import RecordCard from "./RecordCard";
import { useGetShipmentMessagesByShipmentIdQuery } from "store/services/smsLogListApi";

const FieldRow = ({ label, value }) => (
    <Box sx={{ display: "flex", py: 0.25 }}>
        <Box sx={{ width: "30%", color: "text.primary", fontSize: "0.7rem", fontWeight: 600 }}>{label}</Box>
        <Box sx={{ width: "70%", fontSize: "0.74rem", fontWeight: 500, wordBreak: "break-word" }}>
            {value ?? "N/A"}
        </Box>
    </Box>
);

const SmsRecordCard = ({ row }) => (
    <RecordCard>
        <Typography sx={{ fontSize: "0.78rem", fontWeight: 600 }}>
            {row?.messageType || "N/A"}
        </Typography>
        <Divider sx={{ my: 0.5 }} />
        <FieldRow label="Message" value={row?.message} />
        <FieldRow label="Date" value={row?.createdAt ? new Date(row.createdAt).toLocaleString() : "N/A"} />
    </RecordCard>
);

const ShipmentSmsLogCompact = ({ shipmentId }) => {
    const { data: messagesRes, isLoading, isFetching, error } = useGetShipmentMessagesByShipmentIdQuery(shipmentId, {
        skip: !shipmentId,
    });

    const messages = Array.isArray(messagesRes?.data) ? messagesRes.data : [];

    if (isLoading || isFetching) {
        return (
            <Typography sx={{ fontSize: "0.74rem", color: "text.secondary", textAlign: "center", py: 2 }}>
                Loading SMS logs...
            </Typography>
        );
    }

    if (error) {
        return (
            <Typography sx={{ fontSize: "0.72rem", color: "error.main", p: 1 }}>
                {error?.data?.message || error?.message || "Something went wrong"}
            </Typography>
        );
    }

    if (messages.length === 0) {
        return (
            <Typography sx={{ fontSize: "0.74rem", color: "text.secondary", textAlign: "center", py: 2 }}>
                No SMS logs found.
            </Typography>
        );
    }

    return (
        <Box sx={{ p: 1 }}>
            {messages.map((row, idx) => (
                <SmsRecordCard key={row._id || idx} row={row} />
            ))}
        </Box>
    );
};

export default ShipmentSmsLogCompact;